module.exports = __webpack_public_path__ + "img/logo6.18254aa7.png";